// @ubm/ui/components/time-grid — géométrie PURE de la grille temps (aucune date, aucun fuseau : des minutes depuis le début
// de la fenêtre affichée). Extraite d'AgendaTimeGrid (Booking) : mêmes formules, même snap, mêmes bornes. Les appelants
// convertissent minutes ↔ dates avec leurs propres règles (wall-clock DST-safe côté Booking, fuseau IANA côté WeekCalendar).

/** Top/height en % de la fenêtre — même précision que la grille Booking d'origine. */
export function timeGridPercent(minutes: number, windowMinutes: number): string {
  return `${((minutes / windowMinutes) * 100).toFixed(4)}%`;
}

/** y (px dans la colonne) → minutes depuis le début de la fenêtre, bornées à la fenêtre. */
export function yToMinutes(y: number, height: number, windowMinutes: number): number {
  return Math.min(windowMinutes, Math.max(0, (y / height) * windowMinutes));
}

/** Une plage tirée (deux minutes quelconques) → plage snappée, au moins un pas, bornée à la fenêtre. */
export function snapRange(a: number, b: number, snap: number, windowMinutes: number): { startMinute: number; endMinute: number } {
  const lo = Math.min(a, b);
  const hi = Math.max(a, b);
  let startMinute = Math.floor(lo / snap) * snap;
  let endMinute = Math.ceil(hi / snap) * snap;
  if (endMinute <= startMinute) endMinute = startMinute + snap;
  if (endMinute > windowMinutes) {
    endMinute = windowMinutes;
    startMinute = Math.min(startMinute, endMinute - snap);
  }
  return { startMinute, endMinute };
}

/** Déplace une plage de `delta` minutes (snappé), durée conservée, bornée à la fenêtre. */
export function shiftRange(startMinute: number, endMinute: number, delta: number, snap: number, windowMinutes: number): { startMinute: number; endMinute: number } {
  const duration = endMinute - startMinute;
  const stepped = Math.round(delta / snap) * snap;
  const next = Math.min(Math.max(0, startMinute + stepped), Math.max(0, windowMinutes - duration));
  return { startMinute: next, endMinute: next + duration };
}

/** Étire/rétrécit la fin d'une plage de `delta` minutes (snappé) ; au moins un pas, bornée à la fenêtre. */
export function resizeRange(startMinute: number, endMinute: number, delta: number, snap: number, windowMinutes: number): { startMinute: number; endMinute: number } {
  const stepped = Math.round((endMinute + delta) / snap) * snap;
  return { startMinute, endMinute: Math.min(windowMinutes, Math.max(startMinute + snap, stepped)) };
}
